import * as z from "zod/v4";

const armStats = z.object({
  arm: z.enum(["imessage", "sms_forced"]),
  enrolledCustomers: z.number(),
  dispatchesSent: z.number(),
  dispatchesViaImessage: z.number(),
  dispatchesViaSms: z.number(),
  customersWithReply: z.number(),
  replyCount: z.number(),
  revenue: z.number(),
  returnCost: z.number(),
  netLtv: z.number(),
  avgNetLtvPerCustomer: z.number(),
  exchangesCount: z.number(),
  /** ISO currency code for the money fields, or null if mixed/no data. */
  revenueCurrency: z.string().nullable(),
});

/** Handler verifies the test belongs to the caller's account. */
export const iMessageChannelExperimentAnalytics = {
  name: "iMessageChannelExperimentAnalytics" as const,
  input: z.object({ testId: z.string() }),
  output: z.object({
    totalEnrolled: z.number(),
    /** LTV covers fewer customers than `totalEnrolled` (scan capped or Mongo failed). */
    ltvTruncated: z.boolean(),
    imessage: armStats,
    smsForced: armStats,
    /** Global IMESSAGE_CHANNEL_AB_TEST LD flag. Drives the LD-off banner. */
    ldFlagEnabled: z.boolean(),
    windowStart: z.date(),
    windowEnd: z.date().nullable(),
  }),
};
